import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUserAttributes } from "lib/store/services/auth/selectors";

export const ProductBoard = () => {
  const userAttributes = useSelector(selectUserAttributes);

  useEffect(() => {
    const win = window as Window & {
      Featurebase?: {
        (command: string, ...args: unknown[]): void;
        q?: unknown[];
      };
    };

    // Load Featurebase SDK script if not already loaded
    if (!document.getElementById("featurebase-sdk")) {
      const script = document.createElement("script");
      script.src = "https://do.featurebase.app/js/sdk.js";
      script.id = "featurebase-sdk";
      document.head.appendChild(script);
    }

    // Initialize Featurebase
    if (typeof win.Featurebase !== "function") {
      win.Featurebase = function () {
        (win.Featurebase!.q = win.Featurebase!.q || []).push(arguments);
      };
    }

    // Initialize embed widget
    win.Featurebase("init_embed_widget", {
      organization: "brinkcommerce",
      embedOptions: {
        path: "/roadmap",
        filters: "",
      },
      stylingOptions: {
        theme: "light",
        hideMenu: false,
        hideLogo: false,
      },
    });
  }, [userAttributes]);

  return <div data-featurebase-embed></div>;
};
